import { entityService } from '../_services'

const state = {
    all: [],
    buildings: {},
    homebase: {}
}

function disbursementFilter (entities) {
    const result = []
    if (entities.name !== '') {
        result.push({
            text: entities.name,
            value: {
                'entityType': entities.type,
                'entityId': entities.id
            }
        })
    }
    for (let i of entities.children) {
        if (i.name !== '') {
            result.push({
                text: i.name,
                value: {
                    'entityType': i.type,
                    'entityId': i.id
                }
            })
        }
        for (let j of i.children) {
            if (j.name !== '') {
                result.push({
                    text: j.name,
                    value: {
                        'entityType': j.type,
                        'entityId': j.id
                    }
                })
            }
        }
    }
    return result
}

const actions = {
    getAll ({ commit }, organization) {
        commit('getAllRequest')

        entityService.getAllEntities(organization)
            .then(
                respnse => commit('getAllSuccess', respnse.data.data),
                error => commit('getAllFailure', error)
            )
    },
    getBuildings ({ commit }, organization) {
        commit('getBuildingsRequest')

        entityService.getAllBuildings(organization)
            .then(
                response => commit('getBuildingsSuccess', response.data.data),
                error => commit('getBuildingsFailure', error)
            )
    },
    editHomebase ({ commit }, { homebase, data }) {
        commit('setHomebaseRequest')
        entityService.editHomebase(homebase, data)
            .then(
                response => commit('setHomebaseSuccess', response.data),
                error => commit('setHomebaseFailure', error)
            )
    }
}

const mutations = {
    getAllRequest (state) {
        state.all = { loading: true }
    },
    getAllSuccess (state, entities) {
        state.all = {
            entities: entities,
            disbursement: disbursementFilter(entities)
        }
    },
    getAllFailure (state, error) {
        state.all = { error }
    },

    getBuildingsRequest (state) {
        state.buildings = { loading: true }
    },
    getBuildingsSuccess (state, buildings) {
        state.buildings = { buildings: buildings }
    },
    getBuildingsFailure (state, error) {
        state.buildings = { error }
    },

    setHomebaseRequest (state) {
        state.homebase = { loading: true }
    },
    setHomebaseSuccess (state, data) {
        state.homebase = {
            result: data.result,
            message: data.message
        }
    },
    setHomebaseFailure (state, error) {
        state.homebase = { error }
    }
}

export const entity = {
    namespaced: true,
    state,
    actions,
    mutations
}
